import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Route, Routes } from 'react-router-dom';
import { responsiveFontSizes } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';

import ErrDimensions from './components/ErrorPages/ErrDimensions';
import Error404 from './components/ErrorPages/Error404';
import FinalProject from './components/FinalProject/Index';
import Finished from './components/Finished/Index';
// Routes
import Home from './components/Home/Index';
import KonectaWorld from './components/KonectaWorld/Index';
import Lesson from './components/Lessons/Index';
import ForgotPassword from './components/Login/ForgotPassword';
import Login from './components/Login/Index';
import ContactMentor from './components/Mentor/Index';
import Notes from './components/Notes/Index';
import Evaluation from './components/Quizz/Index';
import Statistics from './components/Statistics/Index';
// Layouts
import AuthLayout from './layouts/AuthLayout';
import MainLayout from './layouts/MainLayout';
import theme from './theme/theme';

function App() {
  const themeDefault = responsiveFontSizes(theme);
  const [dimensions, setDimensions] = useState(0);
  ReactGA.initialize('G-91DWB6P8NQ');
  const handleResize = () => setDimensions(window.innerWidth);
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  });
  return (
    <div className="App">
      <ThemeProvider theme={themeDefault}>
        {dimensions <= 900 ? <ErrDimensions /> : (
          <Routes>
            <Route element={<AuthLayout />}>
              <Route path="/" element={<Login />} />
              <Route path="/forgot" element={<ForgotPassword />} />
            </Route>
            <Route element={<MainLayout />}>
              <Route path="/home" element={<Home />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/mentor" element={<ContactMentor />} />
              <Route path="/lesson" element={<Lesson />} />
              <Route path="/quizz" element={<Evaluation />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/notes/:course" element={<Notes />} />
              <Route path="/notes/:course/lessons/:lesson" element={<Notes />} />
              <Route path="/map/:course" element={<KonectaWorld />} />
              <Route path="/map/:course/theme/:theme/:idTopic" element={<KonectaWorld />} />
              <Route path="/finalProject" element={<FinalProject />} />
              <Route path="/finished" element={<Finished />} />
              <Route path="*" element={<Error404 />} />
            </Route>
          </Routes>
        )}
      </ThemeProvider>
    </div>
  );
}

export default App;
